import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";
import API from "../utils/API";
import "../../src/App.css";
import { useHistory } from "react-router-dom";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport variant="contained" color="secondary" />
    </GridToolbarContainer>
  );
}

const TechnicianReport =() =>{
  const history = useHistory();

  const [listView, setUserDate] = useState({});

  const [startDateB, setStartDate] = useState("");
  const [endDateB, setEndDate] = useState("");
  const [id, setId] = useState("");
  const [idFromButtonClick, setIdFromButtonClick] = useState();
  const [startDateFromButtonClick, setStartDateFromButtonClick] = useState();

  const [endDateFromButtonClick, setEndDateFromButtonClick] = useState();

  const [loading, setLoading] = useState(false);

  const options = { month: "long", day: "numeric", year: "numeric" };

  const dateFormatter = new Intl.DateTimeFormat("en-GB", options);

  const columns = [
    { field: "tokenNumber", headerName: "Token No", width: 230 },
    { field: "customerName", headerName: "Customer Name", width: 250 },
    { field: "paymentReceived", headerName: "Payment Received", width: 150 },
    { field: "paymentMode", headerName: "Payment Mode", width: 270 },
     {
      field: "invoiceDate",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => dateFormatter.format(new Date(value)),
    },
  ];

  const handleClick = () => {
    setLoading(!loading);
    setStartDateFromButtonClick(startDateB);
    setEndDateFromButtonClick(endDateB);
    setIdFromButtonClick(id);
    setUserDate({});
  };

  useEffect(() => {
    function daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    }

    var today = new Date();

    let month = today.getMonth() + 1;
    let year = today.getFullYear();

    let lastdate = daysInMonth(today.getMonth() + 1, today.getFullYear());
    if (month !== 10 && month !== 11 && month !== 12) {
      month = `0${month}`;
    }
    const start = `${year}-${month}-01`;
    const end = `${year}-${month}-${lastdate}`;
    console.log(start);
    console.log(end);

    setStartDate(start);
    setEndDate(end);
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem("tokenStore");

    if (!storedToken) {
      history.push("/");
    }

    if (startDateB !== "" && endDateB !== "") {
      API({
        url: `/vendors/${idFromButtonClick}/payments?startDate=${startDateFromButtonClick}&endDate=${endDateFromButtonClick}`,
        // /vendors/13121/payments/startdate&enddate
        headers: { Authorization: `Bearer ${storedToken}` },
      })
        .then((res) => {
          setLoading(false);
          setUserDate(res.data.paymentList);
          console.log(res.data.paymentList);
        })

        .catch((err) => {
          console.log(err);
        });
    }

    // eslint-disable-next-line
  }, [idFromButtonClick, startDateFromButtonClick, endDateFromButtonClick, loading]);

  return (
    <Box alignItems="center" style={{ width: "87%", marginLeft: "15rem" }}>
      <div>
        <form noValidate onSubmit={(e) => e.preventDefault()}>
          <TextField
            onChange={(e) => setStartDate(e.target.value)}
            id="date"
            label="Start Date"
            type="date"
            style={{ transform: "translate(-15%,-20%)" }}
            InputLabelProps={{ shrink: true }}
            value={startDateB}
          />

          <TextField
            id="date"
            label="End Date"
            type="date"
            style={{ transform: "translate(8%,-20%)" }}
            InputLabelProps={{ shrink: true }}
            value={endDateB}
            onChange={(e) => setEndDate(e.target.value)}
          />
           <TextField
            id="outlined-basic"
            label="Enter Vendor ID"
            variant="outlined"
            aria-describedby="my-helper-text"
            style={{ transform: "translate(12%,-20%)" }}
            //  type="text"
            value={id}
            onChange={(e) => setId(e.target.value)}
          />
          <br />

          <Button
            type="submit"
            style={{
              padding: "4px",
              margin: "5px",
              marginTop: "20px",
            }}
            variant="contained"
            color="primary"
            onClick={handleClick}
          >
            Submit
          </Button>
        </form>
        <br />

        <div
          style={{
            height: 400,
            width: "90%",
            background: "transparent",
            color: "black",
            marginTop: 20,
            marginLeft: 10,
          }}
        >
          {listView.length > 0 && (
            <DataGrid
              rows={listView}
              getRowId={(row) => row.tokenNumber}
              columns={columns}
              pageSize={10}
              sortModel={[
                {
                  field: "id",
                  sort: "desc",
                },
              ]}
              components={{
                Toolbar: CustomToolbar,
              }}
            />
          )}

          {loading ? <CircularProgress style={{ marginTop: 50 }} /> : ""}
        </div>
      </div>
    </Box>
  );
}

export default TechnicianReport;